import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { ITabs } from './../Tabs.types';
import { Modal } from '../../Modal/Modal';
import styles from './TabsModal.module.scss';

export const TabsModal: React.FC<ITabs> = ({
  tabs,
  onTabChange,
  allowToChangeTab = true,
  activeTabIndex,
  className,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(activeTabIndex || 0);
  const [isTabsModalOpen, setIsTabsModalOpen] = useState<boolean>(false);

  useEffect(() => {
    if (activeTabIndex !== undefined && activeTabIndex !== activeIndex) {
      setActiveIndex(activeTabIndex);
    }
  }, [activeTabIndex]);

  const handleTabChange = useCallback(
    (index: number) => {
      if (allowToChangeTab) {
        setActiveIndex(index);
      }
      onTabChange?.(index);
    },
    [allowToChangeTab, onTabChange]
  );

  return (
    <>
      <div className={styles['ds-mobile-tabs-container']}>
        {/* Active Tab Display */}
        <div className={styles['active-tab']} role="button" onClick={() => setIsTabsModalOpen(true)}>
          <p>{tabs[activeIndex]?.header ?? 'Tab'}</p>
          <div className={styles['icon']}></div>
        </div>

        <Modal
          visible={isTabsModalOpen}
          className={styles['tabs-modal']}
          onModalClosed={() => {
            setIsTabsModalOpen(false);
          }}
          title={''}
        >
          <div className={styles['tabs-modal-content']}>
            {tabs.map((tab, index) => {
              if (tab.visible === false) {
                return null;
              }
              const isActive = index === activeIndex;
              return (
                <div
                  key={typeof tab.header === 'string' || typeof tab.header === 'number' ? tab.header : `tab-${index}`}
                  className={classNames(
                    isActive ? styles['tab-option-active'] : styles['tab-option'],
                    tab.disabled ? styles['tab-disabled'] : ''
                  )}
                  onClick={() => {
                    if (!tab.disabled) {
                      handleTabChange(index);
                      setIsTabsModalOpen(false);
                    }
                  }}
                >
                  {tab.header}
                </div>
              );
            })}
          </div>
        </Modal>
      </div>
      <div className={className}>{tabs[activeIndex].content}</div>
    </>
  );
};
